import { apiGet, apiPut, apiPost } from "./client";
import type { CV } from "@career-ops-amplify/shared";

/** Fetch the canonical CV. */
export async function getCV(): Promise<CV> {
  return apiGet<CV>("/api/cv");
}

/** Update the CV content. */
export async function updateCV(content: string): Promise<CV> {
  return apiPut<CV>("/api/cv", { content });
}

/** Ingest raw text (plain text or markdown) — parse into the canonical CV. */
export async function ingestCV(text: string): Promise<CV> {
  return apiPost<CV>("/api/cv/ingest", { text });
}